import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const PieChartIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.7666 0.499995V8.73291C10.7666 9.00905 10.9905 9.23291 11.2667 9.23291H19.5C19.7761 9.23291 20 9.00905 20 8.73291C20 3.90982 16.09 0 11.2667 0C10.9905 0 10.7666 0.223855 10.7666 0.499995ZM18.9841 8.23292H11.7667V1.01589C15.6393 1.26302 18.7369 4.36043 18.9841 8.23292ZM9.23337 10.7661V3.03317C9.23337 2.75703 9.0095 2.53317 8.73335 2.53317C3.91035 2.53317 0 6.44366 0 11.2661C0 16.09 3.90985 20 8.73335 20C13.5568 20 17.4667 16.09 17.4667 11.2661C17.4667 10.9899 17.2428 10.7661 16.9667 10.7661H9.23337ZM8.23333 11.2661C8.23333 11.5422 8.4572 11.7661 8.73335 11.7661H16.4508C16.1931 15.8047 12.8366 19 8.73335 19C4.46218 19 1.00004 15.5378 1.00004 11.2661C1.00004 7.16387 4.19564 3.80681 8.23333 3.54907V11.2661Z'
      />
    </svg>
  );
};
